import LocationsIndex from "@page-containers/locations";

const NearMe = () => <LocationsIndex isNearMe={true} />;

export default NearMe;
